import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { Tooltip, Text, Tag } from '@netapp/bxp-design-system-react';
import { useTranslation, Trans } from "react-i18next";
import { allMenus as i18nNamespace } from "../../../../i18n/namespace";
import { isOrgInSafeMode } from "../../../identity-access-management/utils";

const SafeModeTag = () => {
    const { t } = useTranslation(i18nNamespace);
    const selectedOrg = useSelector(state => state.tenancy.selectedOrg);
    const isUserElevated = useSelector(state => state.tenancy?.user?.isUserElevated);
    const isSafeModeFeatureEnabled = useSelector((state) => state.features.active['NetApp.TenancyV4/safemode'] ?? false);
    const orgInSafeMode =  selectedOrg ? isOrgInSafeMode(selectedOrg["tags"]) : false;

    return <>{isSafeModeFeatureEnabled && orgInSafeMode && !isUserElevated && <Tag level={12} style={{ marginLeft: 18 }}>{t("read_only")}
        <Tooltip><Text><Trans i18nKey="read_only_tooltip" t={t} components={{ strong: <strong /> }} /></Text>
        </Tooltip></Tag>}
        {isSafeModeFeatureEnabled && orgInSafeMode && isUserElevated && <Tag level={12} style={{ marginLeft: 18 }}>{t("elevated")}
            <Tooltip><Text><Trans i18nKey="elevated_mode_tooltip" t={t} components={{ strong: <strong /> }} /></Text>
            </Tooltip></Tag>}</>
}
export default SafeModeTag;